function ScreenRestriction({ title, description, imageUrl }) {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6 text-center bg-white rounded-4 shadow-sm p-4 p-md-5">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={title || 'Screen restriction'}
              className="img-fluid mb-4"
              style={{ maxHeight: 260, objectFit: 'contain' }}
            />
          ) : null}

          <h2 className="fw-bold mb-3">{title || 'Unavailable right now'}</h2>
          <p className="text-muted mb-0">{description || 'This page is temporarily unavailable.'}</p>
        </div>
      </div>
    </div>
  );
}

export default ScreenRestriction;
